import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader, SectionTitle, Tabs } from "@/components/kit";
import { JournalComposer } from "@/components/journal/JournalComposer";
import { JournalEntryCard } from "@/components/journal/JournalEntryCard";
import { useJournalEntries } from "@/hooks/useJournalEntries";
import { PROMPT_CATEGORIES } from "@/data/journal";

const CATEGORY_TABS = PROMPT_CATEGORIES.map((c) => ({ id: c.id, name: c.name, icon: c.emoji }));

export default function Journal() {
  const [params] = useSearchParams();
  const [cat, setCat] = useState(() => (CATEGORY_TABS.some((c) => c.id === params.get("cat")) ? params.get("cat") : "gratitude"));
  const { entries, add, remove } = useJournalEntries();

  return (
    <div className="max-w-3xl" data-testid="journal-page">
      <PageHeader back title="Journal" subtitle="Guided prompts to help you process and reflect" />
      <Tabs items={CATEGORY_TABS} value={cat} onChange={setCat} testPrefix="journal-cat" />
      <JournalComposer category={cat} onSave={add} initialPrompt={params.get("prompt")?.slice(0, 300)} />
      <SectionTitle>Past entries ({entries.length})</SectionTitle>
      <div className="space-y-3">
        {entries.map((e) => <JournalEntryCard key={e.id} e={e} onDelete={remove} />)}
      </div>
    </div>
  );
}
